<template lang="pug">
.the-loop-wrapper
  div( v-if='posts.length > 0')
    ul.the-loop
      li( v-for='post in posts' :key='post.id' )
        .title
          router-link( :to="{ name: 'post', params: { slug: post.slug }}" )
            | {{ post.title.rendered }}
        .meta
          | Categories:
          router-link(
            v-for='(cat, index) in post.cats'
            :key='cat.id'
            :to="{ name:'category', params: { category: cat.slug }}"
          )
            | {{ cat.name }}
            span( v-if='index < post.cats.length - 1')
              | ,&nbsp
        .excerpt( v-html='post.excerpt.rendered' )
    ul.pagination( v-if='pagers.length > 1' )
      li.page-item( v-for='( pager, index ) in pagers' :key='index' )
        router-link.page-link(
          :to='{path:$route.fullPath, query: {page : pager}}'
        ) {{pager}}
  div( v-else )
    no-post
</template>

<script lang="js">
import NoPost from './no-post'

export default {
  name: 'the-loop',
  mixins: [],
  components: { NoPost },
  props: [ 'posts', 'pagers' ],
  data() {
    return {
    }
  },
  created() {},
  mounted() {},
  methods: {},
  computed: {}
}
</script>

<style lang="scss">
.the-loop {

}
</style>
